import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardModal from 'shared/StandardModal.jsx';
import StandardTextArea from 'shared/StandardTextArea.jsx';

const CaptainDetailNotesModal = ({
  visible,
  onCancel,
  handleSubmit,
  onSubmit
}) =>(
  <StandardModal
    title="Captain Notes"
    visible={visible}
    onCloseClick={onCancel}>
      <div>
        <form id="captainDetailNotesForm"
          onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <Field
              name="notes"
              component={StandardTextArea}
              label="Notes"
              placeholder="Enter your notes here..."
              style={{height: 200}}
            />
          </div>
          <div className="form-group text-right">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => onCancel()}
              >{'Cancel'}</button>
              {` `}
              <button
                type="submit"
                className="btn btn-primary btn-lg"
              >{'Save Notes'}</button>
          </div>
        </form>
      </div>
    </StandardModal>
);

CaptainDetailNotesModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func
};

export default reduxForm({
  form: 'adminCaptainDetailNotesForm'
})(CaptainDetailNotesModal);



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainDetailNotesModal.jsx